<div class="container">
  <!-- Header -->
  <div class="header d-flex">
    <h2 class="h2">Template for this link:</h2>
    <a (click)="onClose()" class="ml-auto fa fa-close close-modal"></a>
  </div>

  <!-- Links display table -->
  <table class="table sitemate-form-table">
    <thead>
      <tr>
        <th>Template Name</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of taskDefinition.templateMetadata">
        <td>{{ data.name }}</td>
      </tr>
    </tbody>
  </table>
</div>
